<div class="search-gallery">
  <a
    class="search-gallery__item"
    [routerLink]="'trip' | routeTranslate">
    <h4 class="search-gallery__title">{{ 'cherry-meter.trip-1' | i18next }}</h4>
    <picture
      class="cursor-pointer"
      data-image-loading>
      <source
        media="(max-width: 480px)"
        [srcset]="'https://media.sharry.land/app/images/cherry-meter/viaggi-desktop.webp'" />
      <source
        media="(max-width: 768px)"
        [srcset]="'https://media.sharry.land/app/images/cherry-meter/viaggi-desktop.webp'" />
      <source
        media="(max-width: 1024px)"
        [srcset]="'https://media.sharry.land/app/images/cherry-meter/viaggi-desktop.webp'" />
      <img
        alt="itinerary map image"
        [src]="'https://media.sharry.land/app/images/cherry-meter/viaggi-desktop.webp'" />
    </picture>
  </a>

  <a
    class="search-gallery__item"
    (click)="onNavigateTo(searchResultsFilterablesService.experienceFilterableIds)">
    <h4 class="search-gallery__title">{{ 'cherry-meter.trip-2' | i18next }}</h4>
    <picture
      class="search-gallery__image-border"
      data-image-loading>
      <source
        media="(max-width: 480px)"
        [srcset]="'https://media.sharry.land/app/images/cherry-meter/esperienze-desktop.webp'" />
      <source
        media="(max-width: 768px)"
        [srcset]="'https://media.sharry.land/app/images/cherry-meter/esperienze-desktop.webp'" />
      <source
        media="(max-width: 1024px)"
        [srcset]="'https://media.sharry.land/app/images/cherry-meter/esperienze-desktop.webp'" />
      <img
        alt="itinerary map image"
        [src]="'https://media.sharry.land/app/images/cherry-meter/esperienze-desktop.webp'" />
    </picture>
  </a>

  <a
    class="search-gallery__item"
    (click)="onNavigateTo(searchResultsFilterablesService.itemFilterableIds)">
    <h4 class="search-gallery__title">{{ 'cherry-meter.trip-3' | i18next }}</h4>
    <picture
      class="search-gallery__image-border"
      data-image-loading>
      <source
        media="(max-width: 480px)"
        [srcset]="'https://media.sharry.land/app/images/cherry-meter/prodotti-desktop.webp'" />
      <source
        media="(max-width: 768px)"
        [srcset]="'https://media.sharry.land/app/images/cherry-meter/prodotti-desktop.webp'" />
      <source
        media="(max-width: 1024px)"
        [srcset]="'https://media.sharry.land/app/images/cherry-meter/prodotti-desktop.webp'" />
      <img
        alt="itinerary map image"
        [src]="'https://media.sharry.land/app/images/cherry-meter/prodotti-desktop.webp'" />
    </picture>
  </a>
</div>
